import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import heroImg from './images/hero-img.png';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    padding: '2px 0 0 0',
    backgroundColor: '#0a0a0a',
    marginBottom: '0px',
    maxHeight: 475,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 36px',
      maxHeight: 'none',
      marginBottom: '0px',
    }
  },
  heroInner: {
    maxWidth: 1314,
    margin: '0 auto',
    padding: '0 24px',
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '0',
      flexDirection: 'column',
      gap: 0,
      alignItems: 'center',
    }
  },
  heroTextContainer: {
    flex: 1,
    maxWidth: '820px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 'auto',
    marginBottom: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      alignItems: 'center',
      textAlign: 'center',
      maxWidth: '100%',
    }
  },
  heroTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '64px',
    fontWeight: 400,
    lineHeight: '100%',
    marginBottom: '20px',
    color: '#ffffff',
    maxWidth: "90%",
    [theme.breakpoints.down('md')]: {
      fontSize: '46px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '44px',
      lineHeight: '100%',
      maxWidth: '72%',
      margin: '0 auto 16px auto',
      textAlign: 'center',
    }
  },
  heroSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    color: '#FFFFFF',
    lineHeight: '26px',
    marginBottom: '28px',
    fontWeight: 200,
    maxWidth: '640px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      lineHeight: '22px',
      maxWidth: '95%',
      margin: '4px auto 20px auto',
      textAlign: 'center',
    }
  },
  breadcrumbs: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '16px',
    gap: '12px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 400,
    color: '#ffffff',
    '& a': {
      color: '#ffffff',
      textDecoration: 'none',
      transition: 'color 0.2s ease',
      '&:hover': {
        color: '#FE5A97',
      }
    },
    '& span': {
      color: '#FE5A97',
      fontWeight: 500,
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      marginTop: '0px',
      fontSize: '16px',
      gap: '16px',
      margin: '0 auto',
    }
  },
  heroImageContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    }
  },
  heroImage: {
    width: 'auto',
    maxHeight: '450px',
    objectFit: 'contain',
    display: 'block',
  },
}));

export const AboutUsHeroSection = () => {
  const classes = useStyles();
  return (
    <Box className={classes.heroSection}>
      <Box className={classes.heroInner}>
        <Box className={classes.heroTextContainer}>
          <Typography className={classes.heroTitle}>
            More Than a Platform. A Premium Community.
          </Typography>
          <Typography className={classes.heroSubtitle}>
            SugarCribs is a premium creator platform built for independent creators and high-value members seeking a more exclusive, trusted, and rewarding experience. We combine curated discovery, stronger monetization, and privacy-first design to create meaningful creator-member relationships.
          </Typography>
          <Typography className={classes.breadcrumbs}>
            <Link to="/">Home</Link>
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L1 9" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>About Us</span>
          </Typography>
        </Box>
        <Box className={classes.heroImageContainer}>
          <img
            src={heroImg}
            alt="More Than a Platform. A Premium Community."
            className={classes.heroImage}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsHeroSection;
